import { Socket, Manager } from 'socket.io-client';
import { getApiUrl } from './utils';

type SocketVariants = "chat" | "application";

export class SocketClient {
  private manager: Manager;
  private sockets: Map<string, Socket>;

  constructor() {
    this.sockets = new Map();
  }

  initializeManager(): void {
    this.manager = new Manager(getApiUrl(), {
      path: '/socket.io',
      extraHeaders: {
        Authorization: `Bearer ${localStorage.getItem("webSocketToken") || null}`
      },
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
      timeout: 20000
    });
  }

  disconnectManager(): void {
    this.sockets.forEach((socket) => {
      socket.disconnect();
    });
    this.manager = null;
  }

  addNamespace(namespace: SocketVariants): void {
    const socket = this.manager.socket('/' + namespace);
    this.sockets.set(namespace, socket);
  }

  removeNamespace(namespace: SocketVariants): void {
    const socket = this.sockets.get(namespace);
    if (socket) {
      socket.disconnect();
      this.sockets.delete(namespace);
    }
  }

  emit(namespace: SocketVariants, eventName: string, data: any): void {
    const socket = this.sockets.get(namespace);
    if (socket) {
      socket.emit(eventName, data);
    }
  }

  on(namespace: SocketVariants, eventName: string, cb: (message: string) => void): void {
    const socket = this.sockets.get(namespace);
    if (socket) {
      socket.on(eventName, cb);
    }
  }
}